import { render, staticRenderFns } from "./myPPoint.vue?vue&type=template&id=899a20f4&scoped=true"
import script from "./myPPoint.vue?vue&type=script&lang=js"
export * from "./myPPoint.vue?vue&type=script&lang=js"
import style0 from "./myPPoint.vue?vue&type=style&index=0&id=899a20f4&prod&lang=scss"
import style1 from "./myPPoint.vue?vue&type=style&index=1&id=899a20f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899a20f4",
  null
  
)

export default component.exports